import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { getOneBundleOnePrefab, BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { backpackOpenType } from "../../config/backpackConst";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI, normalBackPackSaveI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import BackpackPrefab from "../backpack/BackpackPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class stallItem extends cc.Component {

    @property({type:cc.Node,displayName:"解锁按钮"})
    unlockBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"增加物品按钮按钮"})
    addBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"sp"})
    sp:cc.Node = null;

    @property({type:cc.Node,displayName:"物品frame"})
    objFrame:cc.Node = null;

    @property({type:cc.Node,displayName:"名字frame"})
    nameFrame:cc.Node = null;

    @property({type:cc.Node,displayName:"价格frame"})
    priceFrame:cc.Node = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lb_Name:cc.Label = null;

    @property({type:cc.Label,displayName:"价格文本"})
    lb_price:cc.Label = null;

    @property({type:cc.Label,displayName:"数量文本"})
    lb_count:cc.Label = null;

    isUnlock:boolean = false;

    isSell:boolean = false;

    backItem:normalBackPackSaveI = null;

    backIndex:number = null;
    /**
     * 设置是否已经解锁
     */
    setIsUnlock(isUnlock:boolean,index:number){
        this.isUnlock = isUnlock;
        this.backIndex = index;
        this.updateItem();
    }

    updateItem(){
        this.updateItemBySp();
    }

    updateItemByUnlock(){
        this.unlockBtn.active = false;
        this.addBtn.active = false;
        if(!this.backItem){
            this.objFrame.active = false;
            if(this.isUnlock){
                this.addBtn.active = true;
            }else{
                this.unlockBtn.active = true;
            }
        }else{
            this.objFrame.active = true;
        }
    }

    updateItemBySp(){
        this.unlockBtn.active = false;
        this.addBtn.active = false;
        this.objFrame.active = true;
        if(this.backItem){
            let backpackConfig = backPackEventMap()[this.backItem.backId];
            let spPath = backpackConfig.spPath;
            this.lb_Name.string = backpackConfig.name;
            this.lb_price.string = data_control.getNumberFormat(backpackConfig.sellPrice);
            this.lb_count.string = "×" +  data_control.getNumberFormat(this.backItem.num);
            // 加载一张图片
            let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.backPackGameBundle);
            bundle.load(`backpackAssets/objSp/${spPath}`,cc.SpriteFrame,(err,assets:cc.SpriteFrame)=>{
                if(err){
                    console.debug("加载图片失败",err);
                    return;
                }
                this.sp.getComponent(cc.Sprite).spriteFrame = assets;
            });
        }else{
            this.objFrame.active = false;
            this.updateItemByUnlock();
        }
    }

    async onBtnAdd(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let url = "backpack/backpackPrefab";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url);
        if(prefab){
            let backpack = cc.instantiate(prefab);
            backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.stall,null,(back)=>{
                let item = back as NormalBackpackI;
                let saveItem = NormalGameManager._instance.getGameData().backpack[item.id];
                if(saveItem){
                    this.backItem = saveItem;
                    saveItem.isSell = true;
                    NormalGameManager._instance.writeGameData();
                }
                this.updateItem();
            });
            backpack.setParent(O1HD.Canvas());
        }
    }
    
    onBtnUnlock(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            NormalGameManager._instance.stallManager.setData({unlockItems:[this.backIndex]},true);
            this.isUnlock = true;
            this.updateItem();
        },()=>{},null,"看视频解锁摊位位置");
    }

    async onBtnSp(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.isSell){
            O1HD.getModules().uiControlModule.showMessageBox("该商品正在出售中")
            return;
        }
        let url = "backpack/backpackPrefab";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url);
        if(prefab){
            let backpack = cc.instantiate(prefab);
            backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.stall,null,(back)=>{
                if(this.backItem){
                    this.backItem.isSell = false;
                }
                let item = back as NormalBackpackI;
                let saveItem = NormalGameManager._instance.getGameData().backpack[item.id];
                if(saveItem){
                    this.backItem = saveItem;
                    saveItem.isSell = true;
                    NormalGameManager._instance.writeGameData();
                }
                this.updateItem();
            });
            backpack.setParent(O1HD.Canvas());
        }
    }

    
}
